import { render, staticRenderFns } from "./ReviewReportView.vue?vue&type=template&id=59c3a67b&scoped=true&"
import script from "./ReviewReportView.vue?vue&type=script&lang=js&"
export * from "./ReviewReportView.vue?vue&type=script&lang=js&"
import style0 from "./ReviewReportView.vue?vue&type=style&index=0&id=59c3a67b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c3a67b",
  null
  
)

export default component.exports